const en = {
  navbar: {
    title: 'AI listening and speaking',
    library: 'Library',
    product: 'Scenarios',
    workflow: 'How it works',
    pricing: 'Pricing',
    resources: 'FAQ',
    login: 'Login',
    signup: 'Start free',
    logout: 'Logout'
  },
  userMenu: {
    profile: 'Learning preferences',
    manageBilling: 'Manage / cancel subscription',
    openMenu: 'Open account menu',
    account: 'My account',
    monthlyBalance: 'Monthly balance',
    permanentBalance: 'Permanent credits',
    upgradeTitle: 'Upgrade plan',
    upgradeDescription: 'Unlock more transcription and voice usage',
    buyCreditsTitle: 'Buy credits',
    redeemGiftCode: 'Redeem gift code',
    inviteTitle: 'Refer & Earn',
    tutorial: 'Tutorial',
    feedback: 'Send feedback'
  },
  referral: {
    title: 'Refer & Earn',
    partnerNote: 'As a partner you earn cash commission on referrals instead of the point rewards below.',
    partnerLink: 'Open partner center',
    codeLabel: 'Your invite code',
    linkLabel: 'Invite link',
    copyCode: 'Copy code',
    copyLink: 'Copy link',
    copied: 'Copied',
    copyFailed: 'Copy failed. Select the text and copy it manually.',
    statRewarded: 'Successful invites: {count}',
    statEarned: 'Credits earned: {amount}',
    referredBy: 'Invited by {email}',
    trackSignup: 'Friend signs up',
    trackSignupDesc: 'With your link or invite code',
    trackActivate: 'Starts practicing',
    trackActivateDesc: 'Verifies email and uses {threshold} credits',
    trackActivateReward: 'You +{reward}  Friend +{inviteeReward}',
    trackConvert: 'First payment',
    trackConvertDesc: 'Subscription or credit pack',
    trackConvertReward: 'You +{reward}',
    progressUsed: '{used} / {threshold} used',
    monthlyLimitNote: 'Usage rewards are limited to {limit} a month ({count} earned this month). After that, your friends still get their credits but you do not. The first-payment reward has no monthly limit.',
    listTitle: 'Your invites',
    listEmpty: 'No one has signed up with your code yet. Share your link with friends who are learning English.',
    statusBound: 'Signed up',
    statusActivated: 'Practicing',
    statusConverted: 'Paid',
    capped: 'Monthly limit reached',
    bindTitle: 'Enter an invite code',
    bindHint: 'You can add one within {days} days of signing up. It cannot be changed later.',
    bindPlaceholder: '6-character code',
    bindButton: 'Apply code',
    bindSuccess: 'Invite code applied. Start practicing to unlock your reward.',
    signupCodeLabel: 'Invite code (optional)',
    signupCodePlaceholder: 'Enter it here if you have one',
    invalidCode: 'This invite code does not exist. Check it and try again.',
    loadFailed: 'Could not load your invite details',
    retry: 'Retry',
    errors: {
      invalid: 'This invite code does not exist. Check it and try again.',
      self: 'You cannot use your own invite code',
      already_bound: 'You have already applied an invite code',
      too_old: 'Invite codes can only be added within 7 days of signing up'
    },
    share: {
      title: 'Post about us, get free credits',
      summary: 'At least +{reward} credits, +{per} for every like or save',
      statusApproved: 'Rewarded',
      approvedText: 'Thanks for sharing. {reward} permanent credits have been added.',
      statusPending: 'In review',
      pendingText: 'Submitted {date}. Credits are based on your likes and saves and added automatically once approved.',
      rejected: 'Your last submission was not approved. You can submit a different post.',
      rejectedWithReason: 'Your last submission was not approved: {reason}',
      urlPlaceholder: 'Paste the link to your post',
      submit: 'Submit for review',
      submitted: 'Submitted. We will review it soon.',
      kitCopyLabel: 'Sample caption',
      kitNext: 'Another one',
      kitCopy: 'Copy caption',
      kitNote: 'Posts that copy a template word for word can get flagged as duplicates. Put it in your own words and add a screenshot of your own practice.',
      kitImagesLabel: 'Images (click to save)',
      kitSaveImage: 'Save image',
      stepPost: 'Post about GoodScriber',
      stepPostDesc: 'TikTok, Instagram, YouTube, X, Xiaohongshu and more. Photo or video, share how you use it.',
      stepKeep: 'Submit {days} days after posting',
      stepKeepDesc: 'Keep the post public and let the likes and saves build up. We approve quickly once you submit.',
      stepSubmit: 'Submit the link, get credits',
      stepReward: '+{reward} ~ +∞',
      rangeFrom: 'min',
      rangeLabel: 'At least {reward} credits, no cap',
      stepSubmitDesc: '{reward} guaranteed, plus {per} for every like or save. Once per account.',
      platforms: {
        xiaohongshu: 'Xiaohongshu',
        douyin: 'Douyin',
        tiktok: 'TikTok',
        instagram: 'Instagram',
        youtube: 'YouTube',
        x: 'X (Twitter)',
        other: 'Other'
      },
      errors: {
        invalid_url: 'No link found. Tap Share on your post, copy the link and paste it here.',
        pending: 'You already have a submission in review',
        already_rewarded: 'This account has already received the share reward'
      }
    },
    gift: {
      title: 'Redeem gift code',
      placeholder: '8-character code',
      button: 'Redeem',
      hint: 'Redeems permanent credits. Each code works once per account.',
      success: 'Redeemed. {credits} permanent credits have been added.',
      errors: {
        invalid: 'Gift code not found. Check it and try again.',
        disabled: 'This gift code is no longer valid',
        used_up: 'This gift code has been fully claimed',
        already_redeemed: 'You have already redeemed this gift code'
      }
    },
    rewardAdmin: {
      tab: 'Shares & gift codes',
      shareTitle: 'Share review',
      filterPending: 'Pending',
      filterAll: 'All',
      user: 'User',
      platform: 'Platform',
      post: 'Post',
      submittedAt: 'Submitted',
      status: 'Status',
      action: 'Action',
      reward: 'Credits',
      engagement: 'Likes + saves',
      engagementShort: '{count} likes/saves',
      approve: 'Approve',
      reject: 'Reject',
      rejectPrompt: 'Reason shown to the user (optional)',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      shareEmpty: 'No submissions',
      codesTitle: 'Gift codes',
      credits: 'Credits per code',
      count: 'Number of codes',
      maxRedemptions: 'Redemptions per code',
      note: 'Note (e.g. campaign)',
      generate: 'Generate',
      generated: 'Generated {count} gift codes',
      copyAll: 'Copy new codes',
      code: 'Code',
      used: 'Redeemed',
      createdAt: 'Created',
      viewRedemptions: 'Who redeemed',
      disable: 'Disable',
      enable: 'Enable',
      disabled: 'Disabled',
      codesEmpty: 'No gift codes yet',
      redemptionsEmpty: 'Nobody has redeemed it yet'
    },
    admin: {
      tab: 'Referrals',
      filterPlaceholder: 'Filter by referrer email',
      search: 'Filter',
      clear: 'Clear',
      empty: 'No referrals yet',
      referrer: 'Referrer',
      invitee: 'Invitee',
      status: 'Status',
      used: 'Credits used',
      boundAt: 'Joined',
      rewards: 'Credits granted',
      inviteeReward: 'Invitee',
      referrerReward: 'Referrer',
      conversionReward: 'Payment',
      cappedShort: 'capped',
      total: '{count} records'
    }
  },
  partner: {
    eyebrow: 'GoodScriber Partners',
    title: 'Recommend GoodScriber. Earn a share.',
    subtitle: 'For English creators, teachers and learning communities. Once approved, you get your own invite code and partner center.',
    centerTitle: 'Partner center',
    centerSubtitle: 'Your invite code, referred users and commissions.',
    benefits: {
      commission: { title: 'Cash commission', desc: 'When your audience signs up with your code and pays, you earn a share. Renewals count too.' },
      premium: { title: 'Free Premium', desc: 'Given on approval, so you can get to know the product before recommending it.' },
      audience: { title: 'A better deal for your audience', desc: 'People who sign up with your code get a bigger first-purchase discount than usual.' }
    },
    stepsTitle: 'How it works',
    steps: {
      apply: { title: 'Apply', desc: 'Leave your name, profile link and contact. It takes a minute.' },
      share: { title: 'Get your invite code', desc: 'Once approved, your partner center opens. Share your code or link.' },
      earn: { title: 'Earn on every sale', desc: 'Commissions are recorded automatically and paid out monthly.' }
    },
    rulesTitle: 'Partner terms',
    rules: {
      commission: { title: '{rate}% cash commission', desc: 'When a user who signed up with your code pays, you get {rate}% of what we receive after payment fees.' },
      duration: { title: '{months} months per user', desc: 'Counted from each user’s first payment. Renewals and repeat purchases in that period count.' },
      fans: { title: 'Perks for your audience', desc: 'Users who sign up with your code get 500 points after activation and a first-purchase discount 20 percentage points bigger than usual.' },
      settlement: { title: 'Withdrawable after {days} days', desc: 'Commissions become withdrawable {days} days after payment and are paid in full every month.' },
      refund: { title: 'Refunds and chargebacks', desc: 'If a user is refunded or files a chargeback, that commission is deducted from your next payout.' }
    },
    loginHint: 'Log in or sign up to fill in the application.',
    loginButton: 'Log in to apply',
    loadFailed: 'Could not load: {error}',
    retry: 'Try again',
    status: {
      pending: 'Under review',
      rejected: 'Not approved',
      disabled: 'Paused'
    },
    pendingTitle: 'Application received',
    pendingDesc: 'You applied on {date}. Once approved, this page becomes your partner center.',
    rejectedDesc: 'This application was not approved. You can update it and apply again.',
    disabledDesc: 'Your partnership is paused. New payments do not earn commission. Existing commissions are still paid.',
    form: {
      title: 'Apply to become a partner',
      name: 'Name',
      namePlaceholder: 'What should we call you',
      profileUrl: 'Profile link',
      profileUrlPlaceholder: 'Your YouTube, TikTok or blog link',
      contact: 'Contact',
      contactPlaceholder: 'Email or messaging ID',
      submit: 'Submit application',
      note: 'We will review it soon. The result will show on this page.',
      failed: 'Could not submit: {error}'
    },
    codeLabel: 'Invite code',
    linkLabel: 'Invite link',
    copyCode: 'Copy code',
    copyLink: 'Copy link',
    copied: 'Copied',
    copyFailed: 'Copy failed. Select the text and copy it manually.',
    premiumUntil: 'Your Premium is active until {date}.',
    premiumPaidPlan: 'You already have a paid plan, so the free Premium did not replace it.',
    premiumEnded: 'Your free Premium has ended.',
    stats: {
      invitees: 'Referred users',
      paidInvitees: 'Paying users',
      pending: 'Pending',
      available: 'Withdrawable',
      paid: 'Paid out'
    },
    invitees: {
      title: 'Referred users',
      user: 'User',
      boundAt: 'Signed up',
      status: 'Status',
      netAmount: 'Total received',
      commission: 'Commission',
      endsAt: 'Commission ends',
      empty: 'No one has signed up with your code yet.'
    },
    inviteeStatus: {
      bound: 'Signed up',
      activated: 'Active',
      converted: 'Paid',
      paid: 'Paid'
    },
    commissions: {
      title: 'Commissions',
      date: 'Date',
      user: 'User',
      kind: 'Type',
      netAmount: 'Received',
      commission: 'Commission',
      status: 'Status',
      availableAt: 'Withdrawable on',
      empty: 'No commissions yet.'
    },
    commissionKind: {
      payment: 'Payment',
      refund: 'Refund deduction',
      dispute: 'Chargeback deduction'
    },
    commissionStatus: {
      pending: 'Pending',
      available: 'Withdrawable',
      paid: 'Paid out'
    },
    payouts: {
      title: 'Payouts',
      date: 'Date',
      amount: 'Amount',
      method: 'Method',
      note: 'Note'
    },
    payoutInfo: {
      title: 'Payout details',
      desc: 'Monthly payouts are sent using these details.',
      method: 'Payout method',
      methodPlaceholder: 'e.g. PayPal, Alipay',
      account: 'Account',
      accountName: 'Account holder name',
      save: 'Save payout details',
      saved: 'Payout details saved',
      failed: 'Could not save: {error}'
    }
  },
  partnerAdmin: {
    title: 'Partner admin',
    signedInAs: 'Signed in as {email}',
    refresh: 'Refresh',
    loginHint: 'Log in with an admin account to continue.',
    login: 'Log in',
    forbidden: 'This account does not have admin access.',
    loadFailed: 'Could not load: {error}',
    actionFailed: 'Action failed: {error}',
    filterLabel: 'Filter by status',
    tabs: {
      pending: 'To review',
      approved: 'Approved',
      disabled: 'Disabled',
      rejected: 'Rejected',
      all: 'All'
    },
    status: {
      pending: 'To review',
      approved: 'Approved',
      disabled: 'Disabled',
      rejected: 'Rejected'
    },
    columns: {
      partner: 'Partner',
      contact: 'Contact',
      status: 'Status',
      rate: 'Rate',
      invitees: 'Referred',
      netAmount: 'Received',
      pending: 'Pending',
      available: 'Withdrawable',
      paid: 'Paid out',
      appliedAt: 'Applied'
    },
    empty: 'No partners here yet.',
    code: 'Code',
    application: 'Application',
    appliedAt: 'Applied',
    payoutInfo: 'Payout details',
    payoutMethod: 'Method',
    payoutAccount: 'Account',
    payoutAccountName: 'Holder',
    review: 'Review',
    reviewHint: 'Approving creates an invite code and gives 3 months of Premium.',
    rejectNotePlaceholder: 'Reason (optional, visible to the applicant)',
    approve: 'Approve',
    reject: 'Reject',
    payout: 'Payout',
    payoutHint: '{amount} is withdrawable. Record the payout below after sending it.',
    payoutMethodPlaceholder: 'Method, e.g. PayPal',
    payoutNotePlaceholder: 'Note, e.g. transfer reference',
    markPaid: 'Mark {amount} as paid',
    terms: 'Commission terms',
    ratePercent: 'Rate (%)',
    months: 'Months',
    saveTerms: 'Save terms',
    premium: 'Free Premium',
    premiumUntil: 'Free Premium active until {date}.',
    premiumPaidPlan: 'They have a paid plan (ends {date}), so it was not replaced.',
    premiumNone: 'Current plan: {plan}.',
    premiumMonths: 'Months to add',
    extendPremium: 'Extend Premium',
    revokePremium: 'Revoke Premium',
    account: 'Partner status',
    disable: 'Disable partner',
    enable: 'Enable again',
    paidInvitees: 'Paying users',
    invitees: 'Referred users',
    user: 'User',
    boundAt: 'Signed up',
    firstPaidAt: 'First payment',
    commission: 'Commission',
    endsAt: 'Commission ends',
    noInvitees: 'No referred users yet.',
    commissions: 'Commissions',
    paidAt: 'Date',
    kind: 'Type',
    purchaseType: 'Purchase',
    purchase: {
      subscription: 'Subscription',
      credits: 'Credit pack'
    },
    noCommissions: 'No commissions yet.',
    payouts: 'Payouts',
    amount: 'Amount',
    note: 'Note',
    commissionCount: 'Items'
  },
  creation: {
    title: 'Create practice material',
    balance: 'Credits',
    buy: 'Buy credits',
    loginHint: 'Log in to generate and save.',
    intro: {
      youtube: 'Paste a YouTube link to import the video and generate subtitles.',
      transcribe: 'Upload audio or video to get subtitles you can play and shadow sentence by sentence.',
      speech: 'Enter a script and pick a voice to make your own listening and shadowing material.'
    }
  },
  sidebar: {
    Profile: 'Learning preferences',
    Shortcut: 'Shortcuts',
    workspace: 'Practice area',
    create: 'Create',
    RecentFiles: 'Recent Files',
    Transcribe: 'Transcribe',
    YouTubeImport: 'Import YouTube',
    TextToSpeech: 'Text to Speech',
    Home: 'Home',
    Material: 'Materials',
    CheckIn: 'Track',
    LearningRecords: 'Learning Records',
    VocabularyBook: 'Study notebook',
    Referral: 'Refer & Earn'
  },
  home: {
    welcome: 'GoodScriber',
    kicker: 'AI listening and speaking training',
    heroTitle: 'Listen, repeat, and speak naturally',
    subtitle: 'Turn any video or audio into word-level subtitles, then shadow it sentence by sentence.',
    startButton: 'Start practicing',
    loginToStart: 'Start free',
    tryDemo: 'Try it',
    faqLink: 'View FAQ',
    heroDescription: 'Upload a file or paste a YouTube link. GoodScriber splits it into sentences, plays each one, records your repeat, and scores your pronunciation.',
    desktopRecommendNotice: 'You can listen and practice on your phone. For sentence-by-sentence shadowing, scores, and word lookup, a computer works best.',
    gifCaptions: {
      leftTop: 'Vast listening and speaking materials',
      leftBottom: 'Effectively improve your skills',
      rightTop: 'Upload audio or input text',
      rightBottom: 'Quickly generate subtitles and audio'
    },
    workflow: {
      title: 'Three steps to start shadowing',
      subtitle: 'From picking material to reviewing your score, everything happens in one practice area.',
      steps: {
        library: {
          title: 'Pick something to practice',
          description: 'Choose a video or audio from the library, or upload your own file or paste a YouTube link.',
          alt: 'Two library categories: YouTube Vlog Immersion (video) and IELTS Listening (audio)'
        },
        repeat: {
          title: 'Listen and repeat, one sentence at a time',
          description: 'Playback pauses after each sentence and waits for you. Smart mode continues when you finish; Timed mode uses a fixed pause.',
          alt: 'The current sentence with the playing word highlighted, and the repeat-after bar in Smart mode prompting you to speak'
        },
        score: {
          title: 'Review your score and fix problem words',
          description: 'See your overall, accuracy, completeness, and fluency scores right away. Play the original for any problem word, then try again.',
          alt: 'Real pronunciation result: overall 88, accuracy 89, completeness 83, fluency 100, problem word Many'
        }
      }
    },
    highlights: {
      ranking: 'Speech to Text',
      tts: 'Natural-sounding voice',
      practice: 'Shadowing practice',
      accuracy: '99.8% Accuracy',
      speaker: 'Speaker Recognition',
      security: 'Private & Secure'
    },
    featuresTitle: 'Multilingual Tools for Listening and Speaking',
    scenario: {
      title: 'Built for these goals',
      subtitle: 'Different goals, different starting points.',
      items: {
        ielts: {
          title: 'IELTS listening and speaking',
          description: 'Shadow real IELTS listening tests sentence by sentence to get used to exam pace and phrasing.',
          action: 'Open IELTS materials'
        },
        vlog: {
          title: 'Learn from YouTube',
          description: 'Practice natural pace and everyday expressions with daily vlogs from real creators.',
          action: 'Open Everyday Vlogs'
        },
        interview: {
          title: 'Interviews and talks',
          description: 'Paste your own script, turn it into natural speech, and repeat it until it flows.',
          action: 'Practice your script'
        },
        pronunciation: {
          title: 'Pronunciation',
          description: 'Every sentence gets a pronunciation score and problem-word hints you can compare with the original.',
          action: 'Try the scoring demo'
        }
      }
    },
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Learn more about GoodScriber',
    faq: [
      {
        question: 'What is follow reading practice?',
        answer: 'Repeat-after and shadowing practice involve listening to a short model and reproducing its words, stress, rhythm, and pauses. GoodScriber helps you split material into sentences, replay a line, record your response, and review practice feedback. Results depend on the learner, material, and practice quality.'
      },
      {
        question: 'How can I use text-to-speech for IELTS speaking preparation?',
        answer: 'Paste your own IELTS answer, generate a speech model, and practice it sentence by sentence. Use the audio to notice pauses, stress, and pacing. GoodScriber feedback is for practice and does not represent an official IELTS band score or score prediction.'
      },
      {
        question: 'Why is audio-to-text important for language learning?',
        answer: 'Audio-to-text makes difficult speech searchable and repeatable. Listen first, use the transcript to locate missed phrases, correct important transcription errors, then replay and repeat those lines. A transcript supports this workflow but does not improve listening by itself.'
      },
      {
        question: 'Which languages does GoodScriber support?',
        answer: 'GoodScriber supports multilingual transcription, subtitle translation, and text-to-speech. Available languages vary by feature and processing provider, so check the language selector in the relevant tool before starting a long file.'
      },
      {
        question: 'Can I translate my transcriptions and subtitles?',
        answer: 'Yes. GoodScriber supports subtitle translation and side-by-side study so you can understand source material across languages.'
      },
      {
        question: 'What is GoodScriber?',
        answer: 'GoodScriber is a listening and speaking practice area for language learners. It turns local audio, video, or a speaking script into editable subtitles or practice audio, then supports sentence replay, recording, feedback, and review.'
      },
      {
        question: 'How much does it cost?',
        answer: 'GoodScriber offers both free and paid plans. The free plan includes 200 credits monthly. If all credits are used for one feature, that is about 20 minutes of transcription, 6 minutes of pronunciation scoring, 3,000 characters with Multilingual voices, or 6,000 with Natural voices. The Pro plan provides 5,000 credits (approx. 500 minutes of transcription), while the Premium plan offers 10,000 credits (approx. 1,000 minutes). Transcription, TTS, and pronunciation scoring share the monthly credit balance. See our pricing page for provider-specific rates.'
      },
      {
        question: 'Is GoodScriber secure?',
        answer: 'GoodScriber uses Firebase and Google Cloud infrastructure for account data and file storage. Transcription, voice generation, payments, and analytics may involve providers listed in our Privacy Policy, including OpenAI, Google Cloud, Stripe, and Google Analytics. You can delete uploaded files through the service.'
      },
      {
        question: 'Can I export my transcription files?',
        answer: 'Absolutely. GoodScriber supports multiple export formats including plain text, SRT subtitle files, Word documents, and more. You can easily download and use these files in other applications, making it convenient to integrate into your learning or work process.'
      },
      {
        question: 'Can I export my audio files?',
        answer: 'Yes, GoodScriber allows you to download all audio files generated through text-to-speech. You can use these files for offline learning, creating podcasts, producing videos, or any other purpose. All downloaded audio is in high-quality MP3 format.'
      },
      {
        question: 'How much audio can I convert?',
        answer: 'Conversion capacity depends on your account type. Free accounts receive 200 credits monthly. If all credits are used for one feature, that is about 20 minutes of audio transcription, 6 minutes of pronunciation scoring, 3,000 characters with Multilingual voices, or 6,000 with Natural voices. Professional accounts offer 5,000 credits (approx. 500 minutes of transcription), while Premium accounts provide 10,000 credits (approx. 1,000 minutes). Transcription, TTS, and pronunciation scoring share the monthly credit balance, and unused credits do not roll over.'
      },
      {
        question: 'How do I cancel my subscription?',
        answer: 'Pro and Premium subscriptions renew monthly or yearly until cancelled. You can open Manage subscription from your account menu to cancel through Stripe. Cancellation takes effect at the end of the paid billing period. One-time credit packs do not renew and never expire.'
      }
    ],
    statsTitle: 'Why Language Learners Choose Us',
    stats: {
      title: 'Trusted by Global Users',
      accuracy: 'Accuracy Rate',
      bilingualValue: '57',
      bilingual: 'Languages supported',
      users: 'Active Users',
      hoursTranscribed: 'Hours Transcribed',
      charactersGenerated: 'Characters Generated'
    },
    heroShot: {
      aria: 'Open the demo shown in this screenshot',
      alt: 'GoodScriber practice area: video on the left, bilingual subtitles on the right, current word highlighted while waiting for you to repeat',
      action: 'Try it'
    },
    library: {
      title: 'Real English materials',
      subtitle: 'YouTube vlogs, IELTS tests, podcasts, and TED-Ed, already split into sentences. Pick one that interests you and start shadowing.',
      vlogMedia: 'Video · YouTube',
      vlogTitle: 'Everyday Vlogs',
      vlogDescription: 'Follow real creators through their everyday lives: natural pace, familiar topics, and the English native speakers actually use.',
      vlogPoints: [
        'Grouped by creator, so you can follow one accent and style',
        'Every video shows its length and level, so you can pick the right one',
        'Watch on the left, repeat each sentence on the right, and get a pronunciation score'
      ],
      vlogAction: 'Explore Everyday Vlogs',
      vlogShotAlt: 'Everyday Vlogs category: creator collections on the left, videos with length and level tags on the right',
      moreTitle: 'More categories',
      browseAll: 'Browse all materials',
      video: 'Video',
      audio: 'Audio'
    },
    ctaTitle: 'Improve Your Language Skills Now',
    cta: {
      title: 'Start Your GoodScriber',
      subtitle: 'Focused shadowing and natural speech practice for multiple languages',
      supportLabel: 'Support Email: ',
      notes: ['Built-in demo audio', 'Upload material to practice', 'Sentence-level feedback']
    },
    partnerBand: {
      title: 'Create English content or teach English?',
      desc: 'Become a partner. Recommend GoodScriber to your audience or students, earn on every sale, and get Premium for free.',
      action: 'Become a partner'
    },
    footer: {
      description: 'An AI shadowing tool for speakers, learners, and anyone who wants to speak more naturally.',
      product: 'Product',
      scenarios: 'Scenarios',
      workflow: 'How it works',
      pricing: 'Pricing',
      demoAudio: 'Try it online',
      feedback: 'Send feedback',
      resources: 'Resources',
      faq: 'FAQ',
      legal: 'Legal',
      copyright: '© 2026 GoodScriber. All rights reserved.',
      tagline: 'Built for speaking practice around the world.'
    },
    toolsTitle: 'Tools',
    tools: {
      title: 'Tools',
      list: [
        'Follow-speaking website', 'English follow-speaking', 'Follow-speaking practice', 'Follow-speaking software', 'English speaking website', 'English learning website', 'English listening website',
        'Free text to speech', 'Text-to-speech', 'Text-to-speech software', 'Text-to-speech website', 'Text-to-speech tool',
        'Free audio-to-text', 'Video subtitle generation', 'Audio-to-text', 'Video-to-text', 'Text-to-subtitle', 'Audio-to-Word', 'MP3 to text', 'MP4 to text', 'MP3 to subtitles', 'MP4 to subtitles', 'Recording to text',
        'IELTS listening practice', 'IELTS speaking practice', 'TOEFL speaking practice', 'TOEFL listening practice', 'Listening Track', 'Speaking Track',
        'English text-to-speech', 'Chinese text-to-speech', 'Multilingual audio-to-text', 'Multilingual subtitle generation',
        'Subtitle translation', 'English intensive listening', 'English shadowing', 'Mandarin practice'
      ]
    },
    pricing: {
      title: 'Pricing',
      free: {
        label: 'Explore',
        title: 'Free Plan',
        credits: 'Credits 200 / month',
        pronunciation: 'Pronunciation scoring about 6 min / month',
        transcription: 'Transcription 20 min / month',
        tts: 'TTS up to 6,000 chars / month'
      },
      pro: {
        label: 'Most popular',
        title: 'Pro Plan',
        credits: 'Credits 5,000 / month',
        pronunciation: 'Pronunciation scoring about 167 min / month',
        transcription: 'Transcription 500 min / month',
        tts: 'TTS up to 150,000 chars / month'
      },
      premium: {
        label: 'Power learners',
        title: 'Premium Plan',
        credits: 'Credits 10,000 / month',
        pronunciation: 'Pronunciation scoring about 333 min / month',
        transcription: 'Transcription 1,000 min / month',
        tts: 'TTS up to 300,000 chars / month'
      },
      allowanceNote: 'Pronunciation scoring, transcription, and TTS maximums each assume all monthly credits are used for that one feature; all three share the balance.'
    }
  },
  recentFiles: {
    title: 'Recent Files',
    workspace: 'Practice area',
    subtitle: 'Manage your subtitle and voice projects in one place.',
    fileCount: '{count} projects',
    refresh: 'Refresh',
    name: 'Name',
    uploadedTime: 'Upload Time',
    duration: 'Duration',
    type: 'Type',
    status: 'Status',
    actions: 'Actions',
    transcribe: 'Transcribe',
    textToSpeech: 'Text To Speech',
    youtubeImport: 'Import YouTube',
    noFiles: 'No records',
    loading: 'Loading...',
    opening: 'Opening...',
    loadMore: 'Load more',
    loadingMore: 'Loading...',
    noMoreFiles: 'No more records',
    retry: 'Retry',
    typeSTT: 'STT',
    typeTTS: 'TTS',
    typeTTSSTT: 'TTS-STT',
    typeYouTube: 'YouTube subtitles',
    tokenBalance: 'Balance:',
    premiumUser: 'Premium',
    proUser: 'Pro',
    freeUser: 'Free',
    lowUsageWarning: 'Low token balance.',
    usageExceeded: 'Token balance is insufficient.',
    upgrade: 'Upgrade',
    rename: 'Rename',
    delete: 'Delete',
    processing: 'Processing',
    completed: 'Completed',
    pending: 'Pending',
    error: 'Failed',
    premiumExpiry: 'Expires on {date}',
    dialog: {
      rename: {
        title: 'Rename File',
        placeholder: 'Enter new file name',
        confirm: 'Confirm',
        cancel: 'Cancel'
      },
      delete: {
        title: 'Delete File',
        message: 'Are you sure you want to delete this file?',
        warning: 'This action cannot be undone.',
        confirm: 'Delete',
        cancel: 'Cancel'
      }
    }
  },
  audioUploader: {
    subtitle: 'Upload a material and generate editable subtitles for listening and shadowing.',
    title: 'Speech to Subtitles',
    dragText: 'Drop file here to upload',
    clickText: 'Upload audio or video',
    supportedFormats: 'Drag a file here, or click to choose one',
    selectedFile: 'Selected file',
    uploadError: 'Upload failed',
    conversionError: 'Failed to convert video to audio',
    converting: 'Converting video to audio...',
    uploading: 'Uploading audio...',
    uploadNextStep: 'Subtitle generation starts automatically after upload',
    generatingSubtitles: 'Generating subtitles',
    processing: 'Processing audio...',
    close: 'Close',
    remainingUsage: 'Remaining usage: {count}',
    durationLimit: 'Each file can be up to {maxDuration} minutes long',
    invalidFile: 'Unable to read file, please ensure you upload a valid audio or video file',
    fileTooLarge: 'File size cannot exceed {maxSize}',
    usageCost: 'Usage: {cost} credits',
    insufficientUsage: 'Insufficient credits',
    providerLabel: 'Recognition mode',
    providerHint: 'Use High accuracy for single-language material, or Multilingual for audio that mixes languages.',
    providers: {
      deepgram: 'High accuracy',
      openai: 'Multilingual'
    },
    languageLabel: 'Material language',
    languageHint: 'Choose the source language for single-language material, or use auto detect for mixed audio.',
    languages: {
      english: 'English',
      auto: 'Auto detect',
      chinese: 'Chinese',
      japanese: 'Japanese',
      korean: 'Korean',
      french: 'French',
      german: 'German',
      spanish: 'Spanish',
      italian: 'Italian',
      portuguese: 'Portuguese',
      russian: 'Russian',
      hindi: 'Hindi',
      arabic: 'Arabic'
    }
  },
  youtubeImporter: {
    title: 'Import a YouTube video',
    subtitle: 'Paste a public video link. We will create sentence-level subtitles and save the practice.',
    urlLabel: 'YouTube video URL',
    urlPlaceholder: 'https://www.youtube.com/watch?v=...',
    pasteFailed: 'Unable to read the clipboard. Check your browser permissions.',
    inspect: 'Check video',
    inspecting: 'Checking...',
    duration: 'Duration',
    usage: 'Estimated usage',
    planLimit: 'Per-video limit',
    credits: '{count} credits',
    minutes: '{count} minutes',
    insufficient: 'This video needs {count} credits. Current balance: {balance}.',
    create: 'Import and generate subtitles',
    preparing: 'Creating task...'
  },
  audioPlayer: {
    workspace: 'Practice area',
    playVideo: 'Play video',
    playSegment: 'Play this part',
    pauseVideo: 'Pause video',
    demoAudioName: 'How to Speak English Fluently',
    demoVideoName: 'How to Speak English Fluently',
    back: 'Back',
    readingMode: 'Reading',
    autoMode: 'Auto',
    modeTips: {
      reading: '← : Previous\n → : Next\nSpace: Replay',
      auto: 'Auto play subtitles',
    },
    mode: 'Mode',
    normal: 'Normal',
    repeat: 'Repeat',
    subtitlesMode: 'Subtitles',
    textMode: 'Text',
    readAlongMode: 'Repeat After',
    smartSplit: 'Split',
    smartSplitHint: 'Choose how subtitles are split',
    subtitlesHint: 'Show subtitles',
    textHint: 'Show text',
    readAlongHint: 'Repeat sentence by sentence: smart, timed or retell',
    generateSubtitlesTitle: 'Generate subtitles',
    generateSubtitlesAction: 'Start generating',
    generationSettingsHint: 'Choose a recognition model and material language, then generate subtitles.',
    generationUsage: 'Estimated usage: {count} credits',
    transcriptionModel: 'Recognition model',
    transcriptionLanguage: 'Material language',
    transcriptError: 'Failed to generate transcript',
    insufficientUsage: 'Insufficient credits. Required: {required}, Remaining: {remaining}',
    microphoneError: 'Unable to access microphone. Please check your permissions.',
    microphoneInput: 'Microphone',
    readAlongSettings: 'Read-along settings',
    practiceLanguage: 'Practice language',
    practiceLanguageHint: 'Used for scoring and live recognition.',
    pronunciationScoring: 'Pronunciation scoring',
    pronunciationScoringHint: 'Scores each line you read, at 1 credit per 2 seconds. When off, nothing is scored or charged and only your recording is kept.',
    microphoneSystemDefault: 'System default',
    microphoneDeviceNumber: 'Microphone {number}',
    microphoneRefresh: 'Refresh',
    microphoneRefreshing: 'Refreshing...',
    yourRecordings: 'Your Recordings',
    playbackError: 'Playback failed',
    downloadError: 'Download failed',
    silenceThreshold: 'Silence Threshold',
    silenceTimeout: 'Silence Timeout',
    vadPauseDelay: 'End Detection',
    vadPauseDelayHint: 'Before the last word, only a long enough pause ends the attempt; after it, the next sentence starts quickly.',
    vadPauseDelayDurationHint: 'With scoring off, words are not recognized: once you have spoken for about as long as the original, it counts as reaching the last word.',
    finishPause: 'Wait after the last word',
    unfinishedPause: 'Wait before the last word',
    recordingMode: 'Smart',
    recordingModeTooltip: 'After each sentence, waits for you to repeat. When you finish speaking, it automatically moves to the next sentence.',
    followingMode: 'Timed',
    followingModeTooltip: 'After each sentence, waits for the sentence duration plus the fixed pause, then automatically moves to the next sentence.',
    followingInterval: 'Extra wait per sentence',
    followingIntervalHint: 'After each sentence it waits for the sentence length plus this time, then moves on.',
    retellingMode: 'Retell',
    retellingModeTooltip: 'After each sentence, records you retelling it. No pause ends it; press “Done” or Enter to move on. Not scored.',
    readAlongListenFirst: 'Listen',
    readAlongSpeakNow: 'Repeat',
    readAlongRecording: 'Recording',
    readAlongStillListening: 'Listening',
    readAlongFinish: 'Done',
    readAlongFinishHint: 'End this sentence now (Enter)',
    endDetectionMode: 'Detection',
    liveRecognition: 'Live recognition',
    liveRecognitionFallback: 'By duration',
    liveRecognitionListening: 'Listening…',
    liveRecognitionOff: 'Scoring is off; speaking time is used to tell when you reach the last word',
    liveRecognitionLimit: 'Live recognition limit reached today; speaking time is used to tell when you reach the last word',
    liveRecognitionError: 'Live recognition is unavailable; speaking time is used to tell when you reach the last word',
    tour: {
      next: 'Next',
      skip: 'Skip tutorial',
      replay: 'Tutorial',
      help: 'Help',
      enable: {
        title: 'Turn on Repeat After',
        body: 'Click the highlighted button. Once it is on, playback stops after every sentence and waits for you to speak.',
        action: 'Turn it on',
      },
      listen: {
        title: 'Play one sentence',
        body: 'Press play, click the video, click any line of the transcript, or hit Space. It pauses by itself when the sentence ends.',
        action: 'Play',
      },
      speak: {
        title: 'Now say it out loud',
        body: 'No button to press. When you see the prompt, read the highlighted sentence. It detects when you finish and scores you.',
        scoring: 'Done. Scoring takes a few seconds. Practice keeps going, so carry on with the next sentence.',
        bodyNoScore: 'No button to press. When you see the prompt, read the highlighted sentence. It moves on when you finish.\nScoring is off, so this is recorded but not scored.',
      },
      score: {
        title: 'Check your score',
        body: 'Your score is in. Click it to see word-by-word pronunciation feedback.\n\nScoring uses credits (1 credit per 2 seconds). If you do not need scores, turn scoring off in the read-along settings to record without using credits.',
      },
      modes: {
        title: 'Three ways to practice',
        body: 'Open it to switch:\n· Smart: moves on when you finish speaking\n· Timed: moves on after a fixed pause\n· Retell: say it from memory, recorded but not scored',
      },
      settings: {
        title: 'Read-along settings',
        body: 'Open it to:\n· Pick your microphone and practice language\n· Turn scoring on or off\n· Make the wait longer if it cuts you off too early',
      },
      split: {
        title: 'Sentences too long or too short',
        body: 'Open it to change how the transcript is split: short chunks made for repeating, or full sentences.',
      },
      translate: {
        title: 'Show translation',
        body: 'Open it and pick a language. A translation appears under each sentence.',
      },
      playback: {
        title: 'Playback settings',
        body: 'From left to right:\n· Subtitle font size\n· Volume\n· Speed, slow it down if it is too fast\n· Play mode, pick repeat to drill one sentence',
      },
      finishShort: {
        title: "That's how shadowing works",
        body: 'Press play and finish the last few sentences of this demo. We will suggest what to listen to next. To learn about practice modes, translation and playback speed, tap "More settings".',
        action: 'Keep practicing',
        more: 'More settings',
      },
      finish: {
        title: 'You are ready',
        body: 'Keep practicing this one, or pick something you want to hear from the library. To see this again, open Tutorial in the account menu.',
        library: 'Go to library',
        stay: 'Keep practicing',
      },
    },
    usagePaywall: {
      title: 'You are out of credits this month',
      reason: 'Pronunciation scoring uses 1 credit per 2 seconds of recording. You have run out, so the last sentence was not scored.',
      reset: 'Your {amount} free credits come back on {date}.',
      checkIn: 'Listen for 5 minutes a day to check in and earn {amount} credits.',
      noScore: 'You can keep shadowing with scoring off. Recording is free.',
      continue: 'Keep practicing without scores',
      upgrade: 'See upgrade options',
      dateLocale: 'en-US',
    },
    nextLesson: {
      title: 'Listen to this next',
      intro: 'Demo complete. This one fits your listening level, so you can keep practicing right away.',
      library: 'Browse library',
      start: 'Start learning',
      signup: 'Sign up free to start',
    },
    playRecordings: 'Play all',
    stopRecordings: 'Stop playing recordings',
    myRecordings: 'My recordings',
    recordingStorageHint: 'Recordings stay in this browser only and are cleared after 24 hours. Download them if you want to keep them.',
    playOriginalRecording: 'Play this original recording',
    downloadRecordings: 'Download',
    recordingCount: '{count} clips',
    recordingFileSuffix: 'original-shadowing-recording',
    showSubtitles: 'Show subtitles',
    hideSubtitles: 'Hide subtitles',
    showSubtitlesTooltip: 'Show subtitles',
    hideSubtitlesTooltip: 'Hide subtitles',
    translate: 'Translate',
    translateHint: 'Translate subtitles',
    disableTranslation: 'Disable translation',
    translationError: 'Failed to translate subtitles',
    translating: 'Translating...',
    splitByPractice: 'Shadowing · Standard',
    splitByPracticeShort: 'Shadowing · Short',
    splitByComma: 'By comma',
    splitByPeriod: 'Full sentences',
    splitByPause: 'By pauses',
    noSplit: 'Original segments',
    splitHints: {
      practice: 'Lines stay under about 7 seconds, for everyday shadowing',
      practice_short: 'Lines stay under about 5 seconds, for beginners or fast speech',
      comma: 'Breaks at every comma and full stop',
      period: 'Keeps whole sentences, for careful listening',
      pause: 'Breaks wherever the speaker pauses',
      none: 'Segments from the transcription service',
    },
    exportSettings: 'Export settings',
    moreSettings: 'More settings',
    pronunciationAssessment: {
      assessing: 'Assessing pronunciation',
      assessmentFailed: 'Assessment failed',
      pronunciation: 'Overall',
      accuracy: 'Accuracy',
      fluency: 'Fluency',
      completeness: 'Completeness',
      recognizedText: 'Recognized text',
      problemWords: 'Problem words',
      issue: 'Issue',
      playWordPronunciation: 'Hear it',
      recordAgain: 'Record again',
      feedback: 'Sentence feedback',
      summaryExcellent: 'Good reading. You can move on to the next sentence.',
      summaryGood: 'Mostly good. Review the detailed scores before moving on.',
      summaryWeakWords: 'Mostly good. Focus on the highlighted words.',
      summaryMainIssues: 'Main issues: ',
      summarySeparator: ', ',
      summarySentenceEnd: '.',
      issueAccuracy: 'pronunciation accuracy',
      issueFluency: 'uneven rhythm',
      issueCompleteness: 'missing or unfinished words',
      assessmentLanguage: 'Assessment language',
      pointsCharged: '{points} credits used for this assessment.',
      anonymousAttemptUsed: '1 anonymous assessment used.',
      insufficientPoints: 'Not enough credits. Your recording was kept without a score.',
      anonymousLimit: 'All 5 anonymous assessments have been used today. Try tomorrow or sign in to continue.',
      errorTypes: {
        Omission: 'Omitted',
        Insertion: 'Inserted',
        Mispronunciation: 'Mispronounced',
        UnexpectedBreak: 'Unexpected break',
        MissingBreak: 'Missing break',
        Monotone: 'Monotone',
      },
    },
  },
  sentenceExplanation: {
    action: 'Explain this sentence',
    title: 'AI sentence explanation',
    loading: 'Explaining this sentence...',
    regenerate: 'Explain again',
    retry: 'Try again',
    followUpLabel: 'Ask more',
    followUps: {
      grammar: 'Break it down',
      rephrase: 'Say it differently',
      examples: 'Use it',
    },
    saveToNotebook: 'Add to Study notebook',
    savedToNotebook: 'In Study notebook',
    saveFailed: 'Could not add to Study notebook. Try again.',
    quotaRemaining: '{count} left this month',
    monthlyLimitReached: "You've used this month's explanations. They reset on the 1st.",
    loginRequired: 'Log in to use sentence explanations.',
    generateFailed: 'Could not generate an explanation. Try again.',
  },
  learningAssistant: {
    title: 'Learning assistant',
    pronunciation: 'Pronunciation',
    explanation: 'Sentence explanation',
    noAssessment: 'This sentence has no pronunciation score yet. Complete one recording to see feedback.',
  },
  vocabulary: {
    loading: 'Looking up...',
    addToVocabulary: 'Add to vocabulary',
    saving: 'Saving...',
    saved: 'Saved to vocabulary',
    updated: 'Updated in vocabulary',
    noTranslation: 'No translation found',
    loginRequired: 'Please log in to save words.',
    lookupFailed: 'Lookup failed',
    saveFailed: 'Save failed',
    listen: 'Listen',
    inContext: 'In this sentence',
    otherSenses: 'Other meanings',
    baseForm: 'Base form',
    retry: 'Try again'
  },
  textToSpeech: {
    subtitle: 'Turn text into natural speech with the voice and speed you choose.',
    title: 'Text to Speech',
    textPlaceholder: 'Enter or paste your text here...',
    characterCount: 'characters',
    provider: 'Voice style',
    providers: {
      google: 'Multilingual voices',
      openai: 'Natural voices'
    },
    gender: { female: 'Female', male: 'Male' },
    providerHint: 'Multilingual voices let you pick a language and accent. Natural voices sound closer to a real speaker.',
    voiceSelection: 'Voice Selection',
    voiceLabel: 'Voice',
    speedLabel: 'Speed',
    googleLanguage: 'Language',
    googleVoice: 'Voice',
    usageCost: 'Usage: {cost} credits',
    insufficientUsage: 'Insufficient credits',
    submittingVoice: 'Submitting…',
    errors: {
      emptyContent: 'Please enter some text',
      characterLimitExceeded: 'Character limit exceeded',
      pasteFailed: 'Failed to paste from clipboard',
      generic: 'Something went wrong',
      recordCreationFailed: 'Failed to create recording',
    },
    previewButton: 'Preview voice sample',
    previewError: 'Failed to play preview',
    playVoicePreview: 'Play voice sample'
  },
  exportPanel: {
    export: 'Export',
    downloadAudio: 'Download Audio',
    renameFile: 'Rename File',
    deleteFile: 'Delete File',
  },
  feedback: {
    title: 'Send feedback',
    intro: 'Tell us about a problem or something we could do better.',
    messageLabel: 'Description',
    messagePlaceholder: 'What went wrong, and at which step? Or what would you like us to improve?',
    screenshotsLabel: 'Screenshots',
    screenshotsHint: 'Optional, up to {max}. You can paste with Ctrl+V',
    addScreenshot: 'Click, drop or paste',
    screenshotAlt: 'Screenshot {index}',
    removeScreenshot: 'Remove screenshot {index}',
    emailLabel: 'Contact email',
    emailHint: 'Optional, so we can reply',
    contextNote: 'The current page and browser details are attached to help us investigate.',
    contextNotePlayer: 'The current page, browser details, and the material and sentence you are practicing are attached to help us investigate.',
    submit: 'Send feedback',
    submitting: 'Sending…',
    thanks: 'Thanks, we got your feedback and will look at it soon.',
    thanksDetail: 'If you left an email, we will reply once it is handled.',
    errors: {
      tooManyScreenshots: 'You can add up to {max} screenshots',
      notImage: 'Only PNG, JPG, WebP and GIF images are supported',
      tooLarge: 'Each screenshot must be 5 MB or smaller',
      FEEDBACK_INVALID: 'Something in the form is not valid. Check the description and email, then try again',
      FEEDBACK_RATE_LIMIT: 'Too much feedback sent today. Try again tomorrow, or email goodscriber@gmail.com',
      FEEDBACK_TOO_LARGE: 'The screenshots are too large in total. Remove some and try again'
    },
    admin: {
      tab: 'Feedback',
      title: 'User feedback',
      filterNew: 'Open',
      filterAll: 'All',
      empty: 'No feedback yet',
      anonymous: 'Signed-out visitor',
      contact: 'Contact',
      markResolved: 'Mark handled',
      markNew: 'Reopen',
      status: { new: 'Open', resolved: 'Handled' },
      context: {
        page: 'Page',
        view: 'View',
        audioName: 'Material',
        sentenceIndex: 'Sentence',
        sentenceText: 'Current sentence',
        currentTime: 'Playback position (s)',
        audioId: 'File ID',
        materialId: 'Material ID',
        locale: 'Interface language',
        viewport: 'Window size',
        userAgent: 'Browser'
      }
    }
  },
  common: {
    mainlandAccessNotice: 'In mainland China you need a VPN, otherwise login and videos will not load.',
    error: 'Error',
    success: 'Success',
    loading: 'Loading',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    generate: "Generate",
    processing: "Processing...",
    paste: 'Paste',
    generating: 'Generating...',
    generateSubtitles: 'Generate Subtitles',
    subtitlesGenerated: 'Subtitles generated successfully',
    generateSubtitlesFailed: 'Failed to generate subtitles',
    unknownError: 'An unknown error occurred',
    play: 'Play',
    stop: 'Stop',
    download: 'Download',
  },
  premium: {
    title: 'Choose Your Plan',
    billingPeriod: 'Billing period',
    purchaseMode: {
      label: 'Purchase type',
      subscription: 'Subscription',
      credits: 'Buy credits'
    },
    monthly: 'Monthly',
    yearly: 'Yearly',
    autoRenewal: 'Auto-renewal',
    subscriptionNote: 'Renews automatically. Cancel any time.',
    creditPackNote: 'One-time payment. Credits never expire.',
    allowanceNote: 'Pronunciation scoring, transcription, and TTS maximums each assume all monthly credits are used for that one feature; all three share the balance.',
    referenceNote: {
      yearly: 'The crossed-out price is 12 months at the monthly rate.',
      credits: 'The crossed-out price is the same credits at the 2,000-pack rate.'
    },
    firstPurchase: {
      subscriptionBadge: '{percent}% off your first {months} months',
      subscriptionNote: 'First subscription offer: {percent}% off for {months} months, then the crossed-out regular price from month {nextMonth}. Cancel anytime.',
      creditsBadge: '{percent}% off your first purchase',
      creditsNote: 'First purchase offer: the crossed-out price is the regular price. Applies to your first order only.'
    },
    creditPackAllowanceNote: 'Purchased credits are used after monthly credits. Pro upload, text and queue benefits apply while purchased credits remain.',
    cta: {
      current: 'Current plan',
      pro: 'Choose Pro',
      premium: 'Choose Premium',
      manageExisting: 'Manage current subscription first',
      activePlan: 'Current membership is active',
      included: 'Basic benefits included'
    },
    activeSubscription: {
      title: 'You already have an active membership',
      description: 'Use Stripe billing to change plans or cancel renewal.',
      grantedDescription: 'This membership has no Stripe auto-renewal and does not need cancellation.'
    },
    featureLabels: {
      credits: 'Credits',
      pronunciation: 'Pronunciation scoring',
      transcription: 'Transcription time',
      tts: 'TTS',
      upload: 'Audio/video upload',
      text: 'Text to speech',
      priority: 'Queue'
    },
    freePlan: {
      title: 'GoodScriber Free',
      description: 'Light use',
      price: 'US$0 / month',
      transcriptLimit: '200 Credits Monthly',
      uploadLimit: '20 min / 50MB',
      characterLimit: '5,000 chars/use',
      priority: 'Lower Priority',
      description1: '20 mins transcription; TTS up to 6,000 chars.',
      description2: 'Each file can be up to 20 minutes and 50MB.',
      description3: 'Text to speech supports up to 5,000 characters per use.',
      description4: 'Wait longer before your files are transcribed.',
      specs: {
        credits: '200 / month',
        pronunciation: 'About 6 min / month',
        transcription: '20 min / month',
        tts: 'Up to 6,000 chars / month',
        upload: 'Up to 20 min and 50MB',
        text: 'Up to 5,000 chars/use',
        priority: 'Standard'
      }
    },
    proPlan: {
      title: 'GoodScriber Pro',
      monthlySubscription: 'US$8.99 / month',
      yearlySubscription: 'US$89.90 / year',
      yearlyDiscount: '2 months free',
      description: 'Daily learning',
      transcriptLimit: '5,000 Credits Monthly',
      uploadLimit: '30 min / 100MB',
      characterLimit: '10,000 chars/use',
      priority: 'Higher Priority',
      description1: '500 mins transcription; TTS up to 150,000 chars.',
      description2: 'Each file can be up to 30 minutes and 100MB.',
      description3: 'Text to speech supports up to 10,000 characters per use.',
      description4: "We'll transcribe your files faster with higher priority.",
      specs: {
        credits: '5,000 / month',
        pronunciation: 'About 167 min / month',
        transcription: '500 min / month',
        tts: 'Up to 150,000 chars / month',
        upload: 'Up to 30 min and 100MB',
        text: 'Up to 10,000 chars/use',
        priority: 'Faster'
      }
    },
    premiumPlan: {
      title: 'GoodScriber Premium',
      monthlySubscription: 'US$16.99 / month',
      yearlySubscription: 'US$169.90 / year',
      yearlyDiscount: '2 months free',
      description: 'High-volume use',
      transcriptLimit: '10,000 Credits Monthly',
      uploadLimit: '60 min / 200MB',
      characterLimit: '20,000 chars/use',
      priority: 'Highest Priority',
      description1: '1,000 mins transcription; TTS up to 300,000 chars.',
      description2: 'Each file can be up to 60 minutes and 200MB.',
      description3: 'Text to speech supports up to 20,000 characters per use.',
      description4: "We'll always transcribe your files ASAP with the highest priority.",
      specs: {
        credits: '10,000 / month',
        pronunciation: 'About 333 min / month',
        transcription: '1,000 min / month',
        tts: 'Up to 300,000 chars / month',
        upload: 'Up to 60 min and 200MB',
        text: 'Up to 20,000 chars/use',
        priority: 'Fastest'
      }
    },
    creditPacks: {
      cta: 'Buy credits',
      bestValue: 'Best value',
      featureLabels: {
        balance: 'Credits',
        access: 'Feature limits',
        expiry: 'Expiry'
      },
      2000: {
        title: '2,000 Credits',
        description: 'For occasional projects',
        price: 'US$4.99',
        features: {
          balance: '2,000 permanent credits',
          access: 'Pro benefits while balance remains',
          expiry: 'Never expires'
        }
      },
      5000: {
        title: '5,000 Credits',
        description: 'For regular project work',
        price: 'US$11.99',
        features: {
          balance: '5,000 permanent credits',
          access: 'Pro benefits while balance remains',
          expiry: 'Never expires'
        }
      },
      10000: {
        title: '10,000 Credits',
        description: 'Lowest one-time unit price',
        price: 'US$21.99',
        features: {
          balance: '10,000 permanent credits',
          access: 'Pro benefits while balance remains',
          expiry: 'Never expires'
        }
      }
    },
    premiumType: {
      'monthly_oneTime': '1-Month',
      'quarterly_oneTime': '3-Months',
      'halfYearly_oneTime': '6-Months',
      'monthly_autoRenewal': 'Auto-Renewal',
      'yearly_oneTime': '1-Year',
      'yearly_autoRenewal': 'Yearly Auto-Renewal'
    },
    premiumExpiry: '{date} Expires'
  },
  auth: {
    loginTitle: 'Login',
    signupTitle: 'Sign Up',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    loginButton: 'Login',
    loggingIn: 'Logging in',
    signupButton: 'Sign Up',
    loginWithGoogle: 'Login with Gmail',
    signupWithGoogle: 'Sign up with Gmail',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    errors: {
      invalidCredentials: 'Incorrect email or password.',
      emailNotVerified: 'Please verify your email first.',
      networkError: 'Network connection failed. Check your connection and try again.',
      tooManyRequests: 'Too many attempts. Please try again later.',
      emailInUse: 'This email is already registered.',
      invalidEmail: 'That email address is not valid.',
      weakPassword: 'Password must be at least 6 characters.',
      popupBlocked: 'Your browser blocked the Google sign-in window. Allow pop-ups and try again.',
      unknown: 'Something went wrong. Please try again.'
    },
    welcomeBack: 'Welcome back',
    loginSubtitle: 'Log in to continue your shadowing practice.',
    createAccount: 'Create your free account',
    signupSubtitle: 'Free accounts get 200 credits every month, so you can start shadowing right away.',
    continueWithGoogle: 'Continue with Google',
    orEmail: 'or use email',
    forgotPassword: 'Forgot password?',
    passwordHint: 'At least 6 characters',
    createAccountButton: 'Create account',
    creatingAccount: 'Creating…',
    haveReferral: 'Have an invite code?',
    termsPrefix: 'By signing up you agree to the',
    termsLink: 'Terms of Service',
    termsAnd: 'and',
    privacyLink: 'Privacy Policy',
    termsSuffix: '.',
    goLogin: 'Log in',
    verifyTitle: 'Check your inbox',
    verifyText: 'We sent a verification link to {email}. Open it, then come back to log in.',
    verifyHint: "Didn't get it? Check your spam folder, or resend it.",
    verifiedGoLogin: "I've verified, log in",
    resendVerification: 'Resend',
    resendIn: 'Resend in {seconds}s',
    resendSuccess: 'Sent again. Check your inbox.',
    resetTitle: 'Reset your password',
    resetSubtitle: "Enter the email you signed up with and we'll send you a reset link.",
    sendResetLink: 'Send reset link',
    sendingResetLink: 'Sending…',
    resetSent: 'A reset link was sent to {email}. Check your inbox.',
    backToLogin: 'Back to log in',
    visualTitle: 'Listen to a sentence, say it back, see your score.',
    backToSite: 'Back to GoodScriber',
    loginError: 'Failed to login. Please try again.',
    signupError: 'Failed to sign up. Please try again.',
    googleLoginError: 'Failed to login with Google. Please try again.',
    googleSignupError: 'Failed to sign up with Google. Please try again.',
    passwordTooShort: 'Password must be at least 6 characters long',
    passwordsDoNotMatch: 'Passwords do not match',
    signupSuccess: 'Sign up successful! We have sent a verification link to your email. Please verify before logging in.',
    showPassword: 'Show password',
    hidePassword: 'Hide password'
  },
  paymentSuccess: {
    title: 'Payment Successful!',
    subtitle: 'Thank you for subscribing to GoodScriber {plan}',
    subscriptionConfirmed: 'Your GoodScriber subscription is now active',
    description: 'You now have access to all premium features',
    creditPurchase: {
      subtitle: 'Your permanent credits are ready',
      description: 'They will be used after your monthly credits and never expire.',
      details: 'Credit purchase',
      added: 'Credits added',
      permanentBalance: 'Permanent balance',
      access: 'Feature limits',
      proAccess: 'Pro while balance remains',
      expiry: 'Expiry',
      never: 'Never'
    },
    features: {
      title: 'You can now:',
      list: [
        'More monthly credits for transcription & TTS',
        'Higher audio/video upload limits for your plan',
        'Higher text-to-speech limits for your plan',
        'Higher priority for faster transcription'
      ]
    },
    buttons: {
      backToHome: 'Back to Home',
      viewMembership: 'View Membership'
    }
  },
  membership: {
    details: 'Membership Details',
    plan: 'Plan',
    startDate: 'Start Date',
    endDate: 'End Date',
    type: 'Payment Type',
    autoRenewal: 'Auto-renewal',
    oneTime: 'One-time Payment',
    unknown: 'Unknown Plan',
    planTypes: {
      pro: 'Pro Plan',
      premium: 'Premium Plan',
      monthly: 'Monthly Plan',
      yearly: 'Yearly Plan',
      halfYearly: 'Half-Yearly Plan',
      quarterly: 'Quarterly Plan'
    }
  },
  paymentCancel: {
    title: 'Payment Cancelled',
    description: 'You can try purchasing the membership again at any time',
    buttons: {
      backToHome: 'Back to Home'
    }
  },
  material: {
    title: 'Listening Library',
    subtitle: 'Pick a collection and practice sentence by sentence',
    recentTitle: 'Pick up where you left off',
    recentContinue: 'Continue',
    recentAgain: 'Practice again',
    recentOpening: 'Opening',
    recentUntitled: 'Untitled',
    recentPosition: '{index}/{total}',
    recentPositionOnly: 'Sentence {index}',
    recentPercent: '{percent}% done',
    recentFinished: 'Finished',
    recentMissing: 'This item has been deleted and can’t be opened.',
    recentFailed: 'Couldn’t open it. Try again later.',
    videoSection: 'Video',
    audioSection: 'Audio',
    youtubeVlogTitle: 'Everyday Vlogs',
    youtubeVlogDesc: 'Daily life and travel at natural speed',
    youtubeBeginnerTitle: 'Slow English',
    youtubeBeginnerDesc: 'Animated, slow and clear everyday English',
    youtubeRealLifeTitle: 'Real-life English',
    youtubeRealLifeDesc: 'Ordering, shopping and getting around',
    ieltsTitle: 'IELTS Listening',
    ieltsDesc: 'Cambridge IELTS 5–20 listening tests',
    podcastsTitle: 'Podcasts',
    podcastsDesc: 'EnglishPod dialogues and talks on communication',
    listeningLessonsByLevelTitle: 'Lessons by Level',
    listeningLessonsByLevelDesc: 'One-minute lessons from A1 to C1',
    naturalEnglishConversationsTitle: 'Everyday Conversations',
    naturalEnglishConversationsDesc: '1,600+ short everyday dialogues',
    audiobooksadultsTitle: 'Audiobooks',
    audiobooksadultsDesc: 'Nonfiction audiobooks like Atomic Habits',
    tededTitle: 'TED-Ed',
    tededDesc: 'Short animated lessons on big ideas',
    bbc6minuteTitle: 'BBC 6 Minute English',
    bbc6minuteDesc: 'Six minutes, one topic per episode',
    toeflTitle: 'TOEFL Listening',
    toeflDesc: 'TOEFL conversations and academic lectures'
  },
  materialCategory: {
    subscribers: '{count} subscribers',
    views: '{count} views',
    resultCount: '{count} materials',
    clearFilters: 'Clear filters',
    filterSeparator: ': ',
    levelFilter: 'Level',
    topicFilter: 'Topic',
    levelAll: 'All',
    topicAll: 'All',
    purchaseConfirm: 'Get this material for {price} points',
    generateConfirmTitle: 'Confirm Points Usage',
    generateConfirm: 'This audio requires the points of: ',
    currentPoints: 'Current Points',
    cancel: 'Cancel',
    confirm: 'Confirm',
    processing: 'Opening…',
    pleaseLogin: 'Please login',
    purchaseSuccess: 'Purchase Successful',
    free: 'Free',
    freeUnlocked: 'Unlocked for free. {count} more free unlocks left',
    freeUnlockedLast: 'Unlocked for free. Next materials use points',
    purchaseFailed: 'Purchase Failed',
    insufficientPoints: 'Insufficient Points',
    loadFailed: 'Failed to load material',
    loading: 'Loading...',
    filterAll: 'All',
    filterPurchased: 'Owned',
    filterUnpurchased: 'Locked',
    noResults: 'No matching materials found'
  },
  materialAdmin: {
    title: 'Material Library Admin',
    subtitle: 'Manage categories, collections, audio, and YouTube video materials',
    backToLibrary: 'Back to Library',
    checkingAccess: 'Checking admin access...',
    accessDenied: 'Enter admin password',
    accessHint: 'The password comes from the backend ADMIN_MATERIAL_PASSWORD environment variable.',
    passwordPlaceholder: 'Admin password',
    login: 'Enter Admin',
    logout: 'Exit Admin',
    invalidPassword: 'Invalid admin password',
    browse: 'Browse',
    directory: 'Directory',
    selectDirectory: 'Select a directory',
    itemCount: '{count} items',
    seedYouTubeLibrary: 'Set up YouTube directory',
    seedingYouTubeLibrary: 'Setting up...',
    youtubeLibrarySeeded: 'Added {categories} categories and {collections} channel collections',
    youtubeLibrarySeedFailed: 'Failed to set up the YouTube directory',
    syncYouTubeStats: 'Sync YouTube stats',
    syncingYouTubeStats: 'Syncing...',
    youtubeStatsSynced: 'Updated YouTube stats for {collections} channels and {items} videos',
    youtubeStatsSyncFailed: 'Failed to sync YouTube stats',
    importYouTube: 'Import YouTube',
    importYouTubeTitle: 'Add a YouTube learning material',
    importYouTubeHint: 'Check a public video first, then generate sentence-level subtitles in the background. The item stays hidden while processing.',
    youtubeUrlPlaceholder: 'Paste a YouTube video URL',
    checkVideo: 'Check video',
    checkingVideo: 'Checking...',
    videoChecked: 'Video ready',
    publishAfterProcessing: 'Publish automatically after subtitles are ready',
    createYouTubeMaterial: 'Create material and subtitles',
    creatingYouTubeMaterial: 'Creating...',
    youtubeMaterialQueued: 'YouTube material created. Subtitles are processing in the background.',
    youtubeInspectFailed: 'Unable to read this YouTube video',
    youtubeImportFailed: 'Failed to create YouTube material',
    uploadFiles: 'Upload audio files',
    uploadSelected: 'Upload {count} files',
    uploading: 'Uploading...',
    uploaded: 'Uploaded {count} files',
    uploadFailed: 'Upload failed',
    emptyCollection: 'No materials in this collection yet',
    invalidDocumentId: 'ID cannot contain /. Use letters, numbers, hyphens, or underscores.',
    generateAfterUpload: 'Generate subtitles after upload',
    generateSubtitles: 'Generate Collection Subtitles',
    generatingSubtitles: 'Generating subtitles...',
    generateSubtitlesFailed: 'Failed to generate subtitles',
    subtitlesGenerated: 'Generated subtitles for {count} items',
    subtitlesGeneratedWithFailures: 'Subtitle generation finished: {completed} completed, {failed} failed',
    transcriptionProvider: 'Transcription Provider',
    transcriptionLanguage: 'Transcription Language',
    transcriptionStatus: 'Subtitle Status',
    completed: 'Completed',
    noSubtitles: 'No subtitles',
    categories: 'Categories',
    collections: 'Collections',
    items: 'Items',
    import: 'Import',
    newCategory: 'New Category',
    editCategory: 'Edit Category',
    newCollection: 'New Collection',
    editCollection: 'Edit Collection',
    newItem: 'New Item',
    editItem: 'Edit Item',
    titleZh: 'Chinese Title',
    titleEn: 'English Title',
    itemTitle: 'Item Title',
    descriptionZh: 'Chinese Description',
    descriptionEn: 'English Description',
    coverUrl: 'Cover URL',
    uploadCover: 'Upload cover',
    coverUploading: 'Uploading...',
    coverUploaded: 'Cover uploaded',
    coverUploadedAndSaved: 'Cover uploaded and saved',
    coverUploadFailed: 'Failed to upload cover',
    coverUploadMissingTarget: 'Fill in the category, collection, or item ID first',
    coverAutoHint: 'Upload to generate URL, or leave blank to inherit parent cover',
    sortOrder: 'Sort Order',
    defaultPrice: 'Default Price',
    price: 'Price',
    enabled: 'Visible',
    save: 'Save',
    reset: 'Reset',
    refresh: 'Refresh',
    categoryList: 'Categories',
    collectionList: 'Collections',
    itemList: 'Items',
    category: 'Category',
    collection: 'Collection',
    selectCategory: 'Select category',
    selectCollection: 'Select collection',
    allCategories: 'All categories',
    level: 'Level',
    cefrLevel: 'Level',
    topics: 'Topics',
    topicsHint: 'Topics (up to 2; leave empty to use automatic tags)',
    levelAuto: 'Automatic (currently {level})',
    manualMark: '(manual)',
    gradeLevels: 'Grade levels',
    gradeLevelsConfirm: 'Levels will be written for {graded} items in this category ({skipped} skipped: no transcript or set manually). Distribution: {distribution}',
    gradeLevelsDone: 'Updated levels for {graded} items',
    repriceByDuration: 'Price by duration',
    repriceByDurationConfirm: 'Reset credits for this category by duration: under 10 min 20, under 20 min 30, under 30 min 40, longer 50. {changed} items will change ({skipped} without a duration stay as they are). Distribution: {distribution}',
    repriceTier: '{price} credits: {count}',
    repriceByDurationDone: 'Updated credits for {changed} items',
    tagTopics: 'Tag topics',
    tagTopicsConfirm: 'DeepSeek will tag items in this category that have no topics yet. Manually set topics are left alone. Continue?',
    tagTopicsDone: 'Tagged {tagged}, failed {failed}. {distribution}',
    classifyFailed: 'Something went wrong. Please try again.',
    source: 'Source',
    sourceType: 'Source type',
    audioSource: 'Uploaded audio',
    youtubeUrl: 'YouTube URL',
    audioFilePath: 'Audio Path',
    duration: 'Duration (seconds)',
    tags: 'Tags',
    status: 'Status',
    actions: 'Actions',
    visible: 'Visible',
    hidden: 'Hidden',
    edit: 'Edit',
    hide: 'Hide',
    show: 'Show',
    saved: 'Saved',
    collectionPriceSynced: 'Saved and updated the price of {count} items in this collection',
    searchItems: 'Search items',
    importItems: 'Import Items',
    importHint: 'Supports JSON arrays or CSV. Required fields: id, categoryId, collectionId, audioFilePath.',
    fillExample: 'Fill Example',
    importRows: 'Import {count}',
    preview: 'Preview',
    invalidImportRow: 'Row {index} is missing required fields',
    imported: 'Imported {count} items',
    subtitlesGeneratedSummary: 'Subtitle generation finished: {completed} completed, {skipped} skipped, {failed} failed',
    delete: 'Delete',
    cancel: 'Cancel',
    deleteCollection: 'Delete collection',
    deleteCollectionTitle: 'Delete collection',
    deleteCollectionConfirm: 'Delete "{title}"? The {count} materials in this collection, audio files, and subtitle records will be removed.',
    deleteCollectionSuccess: 'Collection deleted with {count} materials removed',
    deleteCollectionFailed: 'Failed to delete collection',
    deleteItemTitle: 'Delete material',
    deleteItemConfirm: 'Delete "{title}"? The audio file and subtitle record will be removed.',
    deleteItemSuccess: 'Material deleted',
    deleteItemFailed: 'Failed to delete material'
  },
  quickListening: {
    firstQuestion: 'Can you understand this clip?',
    harderQuestion: 'Nice. Ready for a harder one?',
    easierQuestion: "No problem. Here's an easier one",
    play: 'Play',
    pause: 'Pause',
    revealHint: 'Answer after listening and the subtitles will appear',
    yes: 'Yes',
    no: 'No',
    nextClip: 'Next clip',
    seeResult: 'See result',
    resultTitle: 'Your listening is around {level}',
    resultHint: 'The library will start you at this level. Take the full test in your learning profile for a more precise result.',
    retake: 'Try again'
  },
  learnerProfile: {
    sourceLabels: {
      self: 'Self-rated',
      quick: 'Quick check',
      test: 'Test result'
    },
    speakingSetupTitle: 'Now check your speaking',
    speakingSetupHint: 'Read 3 sentences aloud, then answer 2 questions in English. About 3 minutes, microphone needed.',
    speakingResultTitle: 'Your speaking is around {level}',
    speakingResultHint: 'Saved to your learning profile. You can retake it anytime.',
    skipSpeaking: 'Skip for now, browse materials',
    returnToSetup: 'Back to setup',
    continueSetup: 'Continue setting your preferences',
    setupLater: 'Set up later',
    finishSetup: 'Finish and browse materials',
    listeningTestAction: 'Take listening test',
    speakingTestAction: 'Take speaking test',
    levelChoiceHint: 'Choose the closest level, or take a test if you are unsure.',
    title: 'Learning preferences',
    subtitle: 'Tell us your level and interests, and the library will filter materials for you. You can change this anytime.',
    listeningTitle: 'How much English can you understand?',
    listeningHint: 'Pick the closest match. The example materials under each level help you compare.',
    speakingTitle: 'How well can you speak?',
    speakingHint: 'Pick the closest match. Not sure? Skip it and change it later.',
    listening: 'Listening',
    speaking: 'Speaking',
    levelNames: {
      A1: 'Beginner',
      A2: 'Elementary',
      B1: 'Intermediate',
      B2: 'Upper-intermediate',
      C1: 'Advanced',
      C2: 'Proficient'
    },
    listeningLevels: {
      A1: 'I can follow very slow, clear words and simple phrases',
      A2: 'I can follow slow everyday conversations, like asking for directions or shopping',
      B1: 'I get the gist of slow shows, but normal-speed vlogs are hard to follow',
      B2: 'I understand most normal-speed vlogs and interviews',
      C1: 'I can follow fast speech, accents and slang without much trouble',
      C2: 'I understand almost everything, like in my first language'
    },
    listeningExamples: {
      A1: 'Slow animated shorts',
      A2: 'Slow English, graded listening',
      B1: 'Everyday dialogues, IELTS listening',
      B2: 'BBC 6 Minute English, podcasts',
      C1: 'Vlogs, audiobooks',
      C2: 'TV shows and live news without subtitles'
    },
    speakingLevels: {
      A1: 'I can say a few simple words and sentences',
      A2: 'I can handle everyday exchanges with simple sentences',
      B1: 'I can talk about familiar topics but often pause to think',
      B2: 'I can discuss most topics fairly fluently',
      C1: 'I speak naturally and rarely get stuck',
      C2: 'I speak with near-native precision and ease'
    },
    speakingExamples: {
      A1: 'Saying your name and where you are from',
      A2: 'Ordering food, asking for directions',
      B1: 'Talking about work, hobbies and weekend plans',
      B2: 'Giving an opinion with reasons',
      C1: 'Speaking up in meetings, impromptu talks',
      C2: 'Negotiating, debating, telling jokes'
    },
    examplePrefix: 'e.g. ',
    interestsTitle: 'What do you like to listen to?',
    interestsHint: 'Pick a few. The library will put these topics first.',
    goalsTitle: 'Why are you learning English?',
    goalsHint: 'Choose as many as you like.',
    saveFailed: "Couldn't save your learning preferences. Check your connection and try again.",
    syncHint: "You're not logged in, so your learning preferences are saved on this device only. They sync to your account after you log in.",
    onboardingTitle: 'Set your learning preferences',
    takeTest: 'Test my level',
    notSure: 'Not sure? Take the test',
    notSet: 'Not set',
    levelsGroup: 'English level',
    interestsGroup: 'Topics',
    goalsGroup: 'Goals',
    saving: 'Saving…',
    savedState: 'Saved',
    unsavedHint: 'You have unsaved changes',
    saveAction: 'Save changes',
    entryLabel: 'My level',
    entrySetup: 'Set my level',
    skip: 'Skip',
    back: 'Back',
    next: 'Next',
    finish: 'Done',
    topics: {
      'daily-life': 'Daily life',
      travel: 'Travel',
      food: 'Food',
      work: 'Work & career',
      business: 'Business & money',
      tech: 'Tech',
      science: 'Science & nature',
      news: 'News',
      culture: 'Movies & music',
      history: 'History & arts',
      stories: 'Stories & books',
      health: 'Health',
      sports: 'Sports & fitness',
      psychology: 'Psychology & growth',
      study: 'Learning & study'
    },
    goals: {
      conversation: 'Everyday conversation',
      media: 'Watch shows and videos without subtitles',
      work: 'For work',
      abroad: 'Study or live abroad',
      exam: 'Exams (IELTS, TOEFL, etc.)'
    },
    goalDescriptions: {
      conversation: 'Chat naturally with friends and colleagues',
      media: 'Follow shows and YouTube by ear',
      work: 'Meetings, emails, overseas clients',
      abroad: 'Study, move or live abroad',
      exam: 'IELTS, TOEFL listening and speaking'
    }
  },
  levelTest: {
    listeningRange: 'Highest assessed level: C1.',
    speakingRange: 'Highest assessed level: C2.',
    backToProfile: 'Back to learning preferences',
    title: 'English level test',
    subtitle: 'Your learning preferences update when you finish, and the library filters by that level.',
    listeningName: 'Listening test',
    listeningMeta: "10 tasks · About 3–5 min",
    listeningIntro: "Listen and complete 6 multiple-choice questions and 4 sentence dictations. Each clip can be played twice.",
    preparingTest: "Selecting questions…",
    dictationPlayFirst: 'Play the clip to start typing while you listen',
    dictationType: "Sentence dictation",
    comprehensionType: "Comprehension",
    dictationTitle: "Type the complete sentence you hear",
    dictationHint: "You can type while listening. Replaying keeps your text. Capitalisation and punctuation do not affect the result.",
    dictationAnswer: "Your sentence",
    dictationPlaceholder: "Type the English you hear here…",
    dictationShortcut: "Ctrl / ⌘ + Enter to submit; Enter for a new line",
    dictationRecognition: "Dictation word recognition",
    listeningAssessing: "Assessing your listening…",
    listeningAssessingHint: "Checking comprehension and dictation, then considering your responses across difficulty levels.",
    listeningAssessmentFailed: "Assessment could not finish",
    retryAssessment: "Reassess these answers",
    listeningStartFailed: "Questions could not load. Check your connection and try again.",
    listeningSessionExpired: "This test session has expired. Please start again.",
    listeningRateLimit: "Too many assessments in a short time. Please try again later.",
    listeningRetryHint: "Your answers are still on this page. Retry the assessment without taking the test again.",
    referenceSentence: "Reference:",
    wordStatus: {"correct": "Matched", "wrong": "Misheard", "missing": "Missing", "extra": "Extra", "spelling": "Spelling"},
    listeningProgress: 'Question {n} / {total}',
    testProgress: 'Test progress',
    audioLoading: 'Loading audio…',
    audioPlaying: 'Playing — listen to the whole clip',
    audioFailed: 'Audio could not play. Try again; this play does not count.',
    nextQuestion: 'Next question',
    seeResult: 'See result',
    previousQuestion: "Previous",
    partialAnswer: "Partly correct",
    originalAndExplanation: "Transcript and explanation",
    dictationCompactScore: "{accuracy}% words recognized",
    expandAssessment: "Review answers",
    listeningBasis: 'Why you received this level',
    skillBreakdown: 'Comprehension breakdown',
    listeningSkills: { detail: 'Key details', gist: 'Main ideas', intent: 'Speaker intentions', inference: 'Attitude and inference', dictation: 'Sentence dictation' },
    selectedAnswer: 'Your answer:',
    correctAnswer: 'Correct answer:',
    incorrect: 'Incorrect',
    clipTranscript: 'Expand this clip’s transcript',
    replayQuestion: 'Replay question {n}',
    materialSource: 'Library source:',
    speakingName: 'Speaking test',
    speakingMeta: '5 tasks · About 3 min',
    speakingFirstFree: 'Your first test is free',
    speakingCost: '{n} credits charged on completion',
    startingTest: 'Preparing…',
    speakingInsufficientUsage: 'Not enough credits. Add credits before taking another test.',
    speakingIntro: 'Read the first 3 prompts aloud. Answer the last 2 questions in English.',
    startAnswer: 'Start answering',
    start: 'Start test',
    allTests: 'All tests',
    questionNumber: 'Question {n}',
    play: 'Play',
    replay: 'Play again',
    playsLeft: '{n} more play left',
    playShortcut: 'Space to play / replay',
    noPlaysLeft: 'Played twice',
    playFirst: 'Listen to the whole clip before choosing',
    notHeard: "I didn't catch it",
    correct: 'Correct',
    wrong: 'The answer was {answer}',
    listeningResult: 'Your listening level',
    speakingResult: 'Your speaking level',
    savedToProfile: 'Saved to your learning preferences',
    browseMaterials: 'Browse materials at this level',
    retake: 'Retake',
    notAccurate: "Doesn't feel right? You can change it in your learning preferences.",
    openProfile: 'Open learning preferences',
    loginRequired: 'The speaking test needs an account so we can save your result.',
    login: 'Log in',
    lastResult: 'Last result',
    viewReport: 'View last result',
    ratingBasis: 'How your level was determined',
    contentMethod: 'The two answers establish a content level based on vocabulary, grammar, coherence and relevance. Read-aloud pronunciation and speech flow then determine the final level. Individual content levels are for reference.',
    capBasis: 'Your average read-aloud score of {score} allows a maximum of {cap}. Scores below 60 / 75 / 85 cap the level at B1 / B2 / C1 respectively.',
    fluencyBasis: 'Your two answers averaged {speed} words/min, with {pauses} pauses longer than 3 seconds in total.',
    fluencyRule: 'An average below 80 words/min or more than 3 long pauses lowers the final level by one, with A1 as the minimum.',
    insufficientContent: 'Your answers totalled fewer than 15 words. The content sample was insufficient, so the rule assigned A1 without individual content ratings.',
    questionReview: 'Question review',
    transcriptNote: 'These automatic transcripts may contain recognition errors. Content feedback uses this text; pronunciation scores come from the audio assessment.',
    readNumber: 'Read aloud {n}',
    answerNumber: 'Answer {n}',
    recognizedSpeech: 'Recognized reading',
    yourAnswer: 'Your answer · Automatic transcript',
    noTranscript: 'No speech recognized',
    unscoredRead: 'No score; counted as 0 in the average',
    answerContentLevel: 'Content level for this answer',
    longPauseLabel: 'Long pauses (over 3 seconds)',
    nextStep: 'Next step:',
    oldReport: 'This earlier test has no saved question details. New tests will include a full review.',
    micDenied: "We couldn't access your microphone. Allow it in the browser address bar and try again.",
    taskRead: 'Read aloud',
    taskAnswer: 'Answer the question',
    taskProgress: '{n} / {total}',
    readHint: 'Read this sentence aloud.',
    answerHint: 'Answer the question in English. Do not read it aloud.',
    accuracy: 'Accuracy',
    fluency: 'Fluency',
    getReady: 'Get ready',
    prepareRead: 'Read the sentence after the countdown',
    prepareAnswer: 'Think of your answer, then speak after the countdown',
    speakRead: 'Read aloud now',
    speakAnswer: 'Answer now. Do not read the question.',
    listeningToYou: 'Listening to you',
    prepare: 'Recording starts in {n}s',
    recording: 'Recording · {n}s left',
    done: "I'm done",
    processing: 'Scoring…',
    pronunciation: 'Pronunciation',
    speed: 'Speed',
    content: 'Content',
    wordsPerMinute: '{n} words/min',
    cappedNote: 'Your read-aloud pronunciation score capped the final level.',
    slowNote: 'Slow speech or long pauses lowered the level by one.',
    scoreFailed: 'Scoring failed. Please try again later. Incomplete assessments are not charged.',
    recognitionFailed: "Speech recognition failed. This attempt doesn't count. Check your connection and start again.",
    retryTask: 'The speech service dropped, so we switched servers. Please answer this one again.',
    noSpeech: "We couldn't hear you. This attempt doesn't count. Check your microphone and start again.",
    restart: 'Start again'
  },
  planLimit: {
    videoTitle: 'This video is {minutes} min. {plan} allows up to {limit} min per video',
    fileTitle: 'This file is {minutes} min. {plan} allows up to {limit} min per file',
    plans: { free: 'The free plan', pro: 'Pro', premium: 'Premium' },
    upgradeFrom: {
      free: 'Subscribe to Pro or buy any credit pack to import up to 30 minutes. Premium goes up to 60 minutes.',
      pro: 'Upgrade to Premium to import up to 60 minutes.'
    },
    maxed: 'Try a shorter video, or split it into parts and import them separately.',
    upgrade: 'See upgrade options'
  },
  checkIn: {
    celebrationTitle: 'Checked in for today',
    celebrationMilestone: '{streak}-day streak milestone reached',
    celebrationStreak: 'day streak',
    celebrationReward: '+{amount} credits added',
    celebrationFreezeUsed: 'Streak freezes used: {count}. Your streak is safe.',
    celebrationFreezeEarned: '7 days in a row earned you a streak freeze',
    celebrationContinue: 'Keep practicing',
    title: 'Study Track',
    subtitle: 'View your study time records',
    stats: {
      monthlyTotal: 'Monthly Total',
      activeDays: 'Active Days',
      dailyAverage: 'Daily Average',
      days: 'days'
    },
    loading: 'Loading...',
    retry: 'Retry',
    timeFormat: {
      hours: 'h',
      minutes: 'm',
      seconds: 's'
    }
  },
  legal: {
    backToHome: 'Back to Home',
    termsLink: 'Terms of Service',
    privacyLink: 'Privacy Policy',
    refundLink: 'Refund Policy',
    terms: {
      title: 'Terms of Service',
      lastUpdated: 'Last updated: February 20, 2026',
      acceptance: {
        title: '1. Acceptance of Terms',
        content: 'By accessing or using GoodScriber (the "Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.'
      },
      description: {
        title: '2. Description of Service',
        content: 'GoodScriber is an AI-powered language learning platform focused on the "repeat after" (shadowing) method. We provide tools for intelligent sentence segmentation, audio playback with subtitles, repeat-after practice, as well as audio transcription and text-to-speech conversion to support your learning.'
      },
      accounts: {
        title: '3. User Accounts',
        content: 'You must create an account to use certain features of the Service. You can sign up using your email address or Google account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.'
      },
      subscription: {
        title: '4. Payment',
        content: 'Some features require a paid Pro or Premium subscription. Subscriptions renew monthly or yearly until cancelled and include a monthly credit allocation. One-time credit packs are also available; purchased credits never expire and provide Pro feature limits while a balance remains. Prices are subject to change with 30 days notice. All payments are processed securely through Stripe.'
      },
      intellectualProperty: {
        title: '5. Intellectual Property',
        content: 'The Service, including its original content, features, and functionality, is owned by GoodScriber and is protected by international copyright, trademark, and other intellectual property laws. Our AI models and algorithms are proprietary technology.'
      },
      userContent: {
        title: '6. User Content',
        content: 'You retain ownership of all audio files and text content you upload to the Service. By uploading content, you grant us a limited license to process your content solely for the purpose of providing the Service. We do not claim ownership of your content and will not use it for purposes beyond delivering the Service.'
      },
      prohibited: {
        title: '7. Prohibited Uses',
        content: 'You agree not to use the Service for any unlawful purpose, to upload content that infringes on third-party rights, to attempt to gain unauthorized access to the Service, to interfere with or disrupt the Service, or to use the Service to generate harmful or misleading content.'
      },
      limitation: {
        title: '8. Limitation of Liability',
        content: 'The Service is provided "as is" without warranties of any kind. GoodScriber shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service. Our total liability shall not exceed the amount you paid for the Service in the 12 months preceding the claim.'
      },
      termination: {
        title: '9. Termination',
        content: 'We may terminate or suspend your account at any time for violation of these Terms. Upon termination, your right to use the Service will immediately cease. You may cancel your account at any time through your account settings.'
      },
      changes: {
        title: '10. Changes to Terms',
        content: 'We reserve the right to modify these Terms at any time. We will notify users of material changes via email or through the Service. Your continued use of the Service after changes constitutes acceptance of the updated Terms.'
      },
      contact: {
        title: '11. Contact Us',
        content: 'If you have any questions about these Terms of Service, please contact us at {email}.'
      }
    },
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: February 20, 2026',
      intro: {
        title: '1. Introduction',
        content: 'GoodScriber ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our Service.'
      },
      collection: {
        title: '2. Information We Collect',
        content: 'We collect information you provide directly: your email address and display name when you create an account via Google or email sign-up, audio files and text content you upload for processing, and payment information processed securely through Stripe (we do not store your card details). We also automatically collect usage data such as features used and session duration, device information including browser type and operating system, and IP addresses for security and analytics purposes.'
      },
      usage: {
        title: '3. How We Use Your Information',
        content: 'We use your information to provide and maintain the Service, process your audio transcriptions and text-to-speech requests, process payments, send important service-related notifications, improve and optimize the Service, and ensure security and prevent fraud.'
      },
      storage: {
        title: '4. Data Storage and Security',
        content: 'Your data is stored securely using Google Firebase and Google Cloud infrastructure. Audio files are stored in Firebase Cloud Storage with signed URLs for secure access. We implement industry-standard encryption for data in transit (TLS/SSL) and at rest. We retain your uploaded files as long as your account is active. You may delete your files at any time through the Service.'
      },
      thirdParty: {
        title: '5. Third-Party Services',
        content: 'We use the following third-party services: Google Firebase for authentication and data storage, OpenAI Whisper for audio transcription, OpenAI and Google Cloud for text-to-speech, Stripe for payment processing, and Google Analytics for usage analytics. Each third-party service has its own privacy policy governing data handling.'
      },
      cookies: {
        title: '6. Cookies and Local Storage',
        content: 'We use browser local storage to save your language preferences and session data. We use cookies for authentication state management. Google Analytics may set cookies for usage tracking. You can manage cookie preferences through your browser settings.'
      },
      rights: {
        title: '7. Your Rights',
        content: 'You have the right to access, update, or delete your personal information through your account settings, request a copy of your data, opt out of marketing communications, and delete your account and associated data. To exercise these rights, contact us at {email}.'
      },
      children: {
        title: '8. Children\'s Privacy',
        content: 'The Service is not intended for users under 13 years of age. We do not knowingly collect personal information from children under 13. If we discover such information has been collected, we will promptly delete it.'
      },
      changes: {
        title: '9. Changes to This Policy',
        content: 'We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on the Service and updating the "Last updated" date.'
      },
      contact: {
        title: '10. Contact Us',
        content: 'If you have any questions about this Privacy Policy, please contact us at {email}.'
      }
    },
    refund: {
      title: 'Refund Policy',
      lastUpdated: 'Last updated: February 20, 2026',
      overview: {
        title: '1. Overview',
        content: 'At GoodScriber, we want you to be satisfied with your purchase. This Refund Policy outlines the conditions under which refunds may be granted for our paid plans (Pro and Premium).'
      },
      eligibility: {
        title: '2. Refund Eligibility',
        content: 'You may request a full refund within 7 days of your purchase if you have not used more than 30 minutes of transcription or text-to-speech credits. Refund requests made after 7 days or after significant usage of credits will be evaluated on a case-by-case basis. Technical issues that prevent you from using the Service may qualify for a pro-rated refund.'
      },
      process: {
        title: '3. How to Request a Refund',
        content: 'To request a refund, email us at {email} with your account email address, the date of purchase, and the reason for your refund request. We will review your request and respond within 3-5 business days. Approved refunds will be processed through your original payment method via Stripe and may take 5-10 business days to appear on your statement.'
      },
      nonRefundable: {
        title: '4. Non-Refundable Cases',
        content: 'Refunds are generally not provided after the 7-day period, for accounts that have been terminated for Terms of Service violations, or for credits that have already been consumed.'
      },
      cancellation: {
        title: '5. Subscription Cancellation',
        content: 'You may cancel a subscription through the Stripe billing portal at any time. Access continues until the end of the current paid billing period, then the account returns to the free plan. Permanent purchased credits remain available and do not expire. Uploaded files and data remain accessible.'
      },
      contact: {
        title: '6. Contact Us',
        content: 'For refund requests or billing questions, please contact us at {email}. We aim to resolve all refund inquiries promptly and fairly.'
      }
    }
  }
}

export default en
